import axios from 'axios';

const state = {
  timezones: {},
};

const mutations = {
  setTimezones: (st, payload) => {
    st.timezones = payload;
  },
};

const actions = {
  getTimezones: ({ commit }) => {
    axios.get('values/timezones').then(res => {
      commit('setTimezones', res.data);
    });
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/timezones.js